var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrading = function SvgTrading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.054 38.98 5 29.928l9.054-9.054 1.6 1.6-6.338 6.32h15.626v2.268H9.317l6.338 6.32zm19.892-11.872-1.6-1.6 6.339-6.32H23.057V16.92h15.628l-6.339-6.339L33.946 9 43 18.054z"
  })));
};
export default SvgTrading;